import topMenu from '@/common/lang/zh/TopMenu/index'
import verification from '@/common/lang/zh/Verification'
import confirm from '@/common/lang/zh/Confirm'
import legalPerson from '@/common/lang/zh/LegalPerson'
import ekyc from '@/common/lang/zh/EKYC'
import storeInfo from '@/common/lang/zh/StoreInfo'
import settlement from '@/common/lang/zh/Settlement'
import file from '@/common/lang/zh/File'
import successPage from '@/common/lang/zh/SuccessPage'

export default {
  yes: '是',
  yes2: '是',
  un: '不是',
  no: '没有',
  and: '有',
  usable: '符合',
  submit:'提交',
  next: '下一步',
  ok: '确认',
  edit: '修改',
  reset: '重置',
  newcreate:'新增店铺',
  homeTitle: 'Japan GlobePay自助注册系统',
  start: '开始',
  required: '必填项',
  no_pass: '该选项无法通过',
  noAccount:'该用户没有申请过，请重新申请！',
  ...topMenu,
  ...verification,
  ...confirm,
  ...legalPerson,
  ...ekyc,
  ...storeInfo,
  ...settlement,
  ...file,
  ...successPage
}
